import React, { useEffect, useState } from 'react';

import JsonView from '@uiw/react-json-view';
import { githubLightTheme } from '@uiw/react-json-view/githubLight';
import { Card, Divider, Form, Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { GeoVictoriaMigrationLogRowSchema } from 'scenes/GeoVictoria/GeoVictoriaToBukMigration/GeoVictoriaToBukMigration';

import appI18n from '../../../../config/i18n';

interface BukMigrationDetailModalProps {
  selectedLog: GeoVictoriaMigrationLogRowSchema;
  handleBukMigrationDetailModalCancel: () => void;
  isBukMigrationDetailModalOpen: boolean;
}

const COLLAPSE_NUMBER = 2;

function BukMigrationDetailModal({
  selectedLog,
  handleBukMigrationDetailModalCancel,
  isBukMigrationDetailModalOpen,
}: BukMigrationDetailModalProps) {
  const [form] = Form.useForm();
  const [collapse] = useState(COLLAPSE_NUMBER);
  const { t } = useTranslation(undefined, { i18n: appI18n });

  useEffect(() => {
    if (isBukMigrationDetailModalOpen) {
      form.resetFields();
    }
  }, [isBukMigrationDetailModalOpen]);

  return (
    <Modal
      title={t(
        'scenes.buk.buk_to_geo_victoria_migration.components.buk_migration_detail_modal.title',
        { id: selectedLog.id }
      )}
      open={isBukMigrationDetailModalOpen}
      footer={false}
      onCancel={handleBukMigrationDetailModalCancel}
      maskClosable={false}
      destroyOnClose
    >
      <Divider style={{ marginTop: '15px', marginBottom: '15px' }} />

      <Form layout="vertical">
        <Form.Item
          label={t(
            'scenes.buk.buk_to_geo_victoria_migration.components.buk_migration_detail_modal.labels.process_type'
          )}
        >
          <Input
            readOnly
            value={
              selectedLog.key ===
              'BUK_LICENCE_MIGRATION_TO_GEO_VICTORIA_PROCESS'
                ? t(
                    'scenes.buk.buk_to_geo_victoria_migration.scene.table.key.licence_migration'
                  )
                : selectedLog.key
            }
          />
        </Form.Item>

        <Form.Item
          name="params"
          label={t(
            'scenes.buk.buk_to_geo_victoria_migration.components.buk_migration_detail_modal.labels.params'
          )}
        >
          <Card>
            <JsonView
              value={selectedLog.params}
              style={githubLightTheme}
              collapsed={collapse}
            />
          </Card>
        </Form.Item>

        <Form.Item
          name="payload"
          label={t(
            'scenes.buk.buk_to_geo_victoria_migration.components.buk_migration_detail_modal.labels.payload'
          )}
        >
          <Card>
            <JsonView
              value={selectedLog.payload}
              style={githubLightTheme}
              collapsed={collapse}
            />
          </Card>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default BukMigrationDetailModal;
